import { IconMenu2, IconChevronRight } from '@tabler/icons-react';
import Link from 'next/link';
import { useState } from 'react';
import Logo from '@/components/common/logo';
import { Button } from '@/components/ui/button';
import { Sheet, SheetClose, SheetContent, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { useCurrentUser } from '@/features/auth/hooks/use-current-user';
import { Category, useNavigation } from '@/hooks/use-navigation';
export function MobileDrawer() {
  const {
    categories
  } = useNavigation();
  const [isOpen, setIsOpen] = useState(false);
  const {
    data
  } = useCurrentUser();
  const user = data;
  return <Sheet open={isOpen} onOpenChange={open => setIsOpen(open)} data-sentry-element="Sheet" data-sentry-component="MobileDrawer" data-sentry-source-file="mobile-drawer.tsx">
      <SheetTrigger asChild data-sentry-element="SheetTrigger" data-sentry-source-file="mobile-drawer.tsx">
        <button type="button" className="relative rounded-md bg-white p-2 text-gray-400 lg:hidden">
          <span className="sr-only">Open menu</span>
          <IconMenu2 className="h-6 w-6" aria-hidden="true" data-sentry-element="IconMenu2" data-sentry-source-file="mobile-drawer.tsx" />
        </button>
      </SheetTrigger>
      <SheetContent className="w-[300px]" data-sentry-element="SheetContent" data-sentry-source-file="mobile-drawer.tsx">
        <SheetHeader data-sentry-element="SheetHeader" data-sentry-source-file="mobile-drawer.tsx">
          <SheetTitle data-sentry-element="SheetTitle" data-sentry-source-file="mobile-drawer.tsx">
            <Logo data-sentry-element="Logo" data-sentry-source-file="mobile-drawer.tsx" />
          </SheetTitle>
        </SheetHeader>

        <div>
          <ul className="mt-4 -mx-6">
            {categories.map((category, index) => <CategoryMobileMenu key={index} category={category} closeParentMenu={() => setIsOpen(false)} />)}
            {user && <>
                <li>
                  <Link className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100" href="/orders">
                    Orders
                  </Link>
                </li>
                <li>
                  <Link className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100" href="/sellinghub">
                    Seller account
                  </Link>
                </li>
              </>}
            <li>
              <a className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100" href="https://about.shopzaars.com/how-it-works" target="_blank">
                How it works
              </a>
            </li>
            <li>
              <a href="https://about.shopzaars.com/cloth-and-culture" target="_blank" className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100">
                cloth & culture
              </a>
            </li>
            <li>
              <a href="https://about.shopzaars.com/our-story" target="_blank" className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100">
                Our Story
              </a>
            </li>
            {!user && <>
                <li>
                  <a className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100" href="/signup">
                    Sign up
                  </a>
                </li>
                <li>
                  <a className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100" href="/signin">
                    Log in
                  </a>
                </li>
              </>}
          </ul>
        </div>

        <SheetFooter className="flex justify-center p-4" data-sentry-element="SheetFooter" data-sentry-source-file="mobile-drawer.tsx">
          <SheetClose asChild data-sentry-element="SheetClose" data-sentry-source-file="mobile-drawer.tsx">
            <Button className="w-full" type="submit" data-sentry-element="Button" data-sentry-source-file="mobile-drawer.tsx">
              Back
            </Button>
          </SheetClose>
        </SheetFooter>
      </SheetContent>
    </Sheet>;
}
function CategoryMobileMenu({
  category,
  closeParentMenu
}: {
  category: Category;
  closeParentMenu: () => void;
}) {
  return <>
      <Sheet data-sentry-element="Sheet" data-sentry-source-file="mobile-drawer.tsx">
        <SheetTrigger asChild data-sentry-element="SheetTrigger" data-sentry-source-file="mobile-drawer.tsx">
          <li>
            <button className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100">
              {category.name}
              <IconChevronRight className="text-gray-400" data-sentry-element="IconChevronRight" data-sentry-source-file="mobile-drawer.tsx" />
            </button>
          </li>
        </SheetTrigger>
        <SheetContent className="w-[300px]" overlayClassName="bg-black/0" data-sentry-element="SheetContent" data-sentry-source-file="mobile-drawer.tsx">
          <SheetHeader data-sentry-element="SheetHeader" data-sentry-source-file="mobile-drawer.tsx">
            <Logo data-sentry-element="Logo" data-sentry-source-file="mobile-drawer.tsx" />
            <SheetTitle className="font-avenir" data-sentry-element="SheetTitle" data-sentry-source-file="mobile-drawer.tsx">
              <p className="text-xl text-left font-bold mt-3 -mx-2">
                {category.name}
              </p>
            </SheetTitle>
          </SheetHeader>

          <ul className="mt-2 -mx-6 mb-4 h-3/4 overflow-scroll overflow-x-hidden">
            {category.sections?.[0]?.items.map((item, index) => {
            return <li key={index}>
                  <SheetClose asChild>
                    <Link onClick={closeParentMenu} href={`/search/${category.id}?category=${item.href}`} className="flex items-center justify-between w-full font-semibold border-b border-b-gray-200 py-4 px-4 hover:bg-gray-100">
                      {item.name}
                    </Link>
                  </SheetClose>
                </li>;
          })}
          </ul>
          <SheetFooter className="flex justify-center p-4" data-sentry-element="SheetFooter" data-sentry-source-file="mobile-drawer.tsx">
            <SheetClose asChild data-sentry-element="SheetClose" data-sentry-source-file="mobile-drawer.tsx">
              <Button className="w-full" type="submit" data-sentry-element="Button" data-sentry-source-file="mobile-drawer.tsx">
                Back
              </Button>
            </SheetClose>
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </>;
}